import { ODataSelect } from "@iconics/core";
import { StorageTypeEnum, HistoryStorageMethodEnum, BuiltInType } from '@iconics/providers.fadx-platform-api-client-v2'

export class Attribute extends ODataSelect
{
    public Id = 0;
    public Name = '';
    public BuiltInType: BuiltInType | '' = '';
    public IsArray: boolean | null = null;
    public IsMandatory: boolean | null = null;
}

export class Entity extends ODataSelect
{
    Id = '';
    Name = '';
    DisplayName: string | null = '';
    Package_ID = '';
    StorageType: StorageTypeEnum | '' = '';
    HistoryStorageMethod: HistoryStorageMethodEnum | '' = '';
    AuditLogDisabled = 0;
    EventPrimaryKeyField_ID?= 0;
    EventTimeField_ID?= 0;
}
